import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ComplementoFaturaCteModel } from "src/app/@feature/consultas/consultas/complemento-fatura-cte/complemento-fatura-cte.model";
import {
  BaseCrudService,
  montarQueryString,
} from "../base-crud/base-crud.service";

@Injectable({
  providedIn: "root",
})
export class ComplementoFaturaCteService extends BaseCrudService {
  /*
    Informar a rota do Controller correspondente na API
    */
  apiController = "ComplementoFaturaCTe";

  /*
    URLS principais
    */
  consultarUrl = (input: ComplementoFaturaCteModel) =>
    `Grid/Filtra?${montarQueryString(input)}`;
  excelUrl = (input: ComplementoFaturaCteModel) =>
    `Grid/ExportarExcel?${montarQueryString(input)}`;
  atualizarUrl = (input: any) => `Atualizar`;
  cadastrarUrl = (input: any) => `Inserir`;

  constructor(public override http: HttpClient) {
    super(http);
  }

  public exportarRelatorio(obj): Observable<any[]> {
    return this.get<any[]>(`ExportarRelatorio?${montarQueryString(obj)}`);
  }

  public listarStatusLote(): Observable<any[]> {
    return this.get<any[]>(`Dropdown/ListarStatusLote`);
  }

  public listarClientes(): Observable<any[]> {
    return this.get<any[]>(`Dropdown/ListarClientes`);
  }

  public downloadTemplateCTEAutorizado(): Observable<any[]> {
    return this.get<any[]>(`CTesAutorizados/ExportarTemplate`);
  }

  public uploadExcel(obj: any): Observable<any> {
    return this.put<any>(`CTesAutorizados/Upload`, obj);
  }

  public exportarExcelCTEErros(obj): Observable<HttpResponse<any>> {
    return this.post(`CTesComErros/Processar?${montarQueryString(obj)}`, obj);
  };

}
